// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Wg3Q","legacyBtn":"MutateMid_legacyBtn__2A0fN"};